export default "/images/a610a8efaa40bb90086806e080ded20a.avif";